"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _galleryComponent = require("../../galleryComponent");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ItemDescription =
/*#__PURE__*/
function (_GalleryComponent) {
  _inheritsLoose(ItemDescription, _GalleryComponent);

  function ItemDescription() {
    return _GalleryComponent.apply(this, arguments) || this;
  }

  var _proto = ItemDescription.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        description = _this$props.description,
        style = _this$props.style,
        spanStyle = _this$props.spanStyle;
    return _react["default"].createElement("div", {
      className: 'gallery-item-description',
      "data-hook": "item-description",
      style: style
    }, description.split('\n').map(function (i, key) {
      return _react["default"].createElement("span", {
        key: key,
        style: spanStyle
      }, i, _react["default"].createElement("br", null));
    }));
  };

  return ItemDescription;
}(_galleryComponent.GalleryComponent);

exports["default"] = ItemDescription;